import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'

const LevelRepository = RepositoryFactory.get('level')

class LevelService {
  static async getLevels () {
    try {
      return await LevelRepository.getLevels()
    } catch (error) {
      console.log(error)
    }
  }
}

export default LevelService
